import { configureStore } from '@reduxjs/toolkit';
import claimReducer from './slices/claimSlice';
import policyReducer from './slices/policySlice';

export const store = configureStore({
  reducer: {
    claim: claimReducer,
    policy: policyReducer,
  },
});

export * from './slices';
